module.exports = {
  PASSPORT_CLIENT_GENERAL_ERROR: 4600,
  PASSPORT_CLIENT_CANNOT_UPSERT: 4601,
  PASSPORT_CLIENT_CANNOT_REGISTER: 4602,
  PASSPORT_CLIENT_CANNOT_AUTHENTICATE: 4603,
  PASSPORT_CLIENT_CANNOT_CHECK: 4604,
  PASSPORT_CLIENT_CANNOT_CHECK_BASIC: 4605,
  PASSPORT_CLIENT_CANNOT_CHECK_OTP: 4606,
  PASSPORT_CLIENT_TOKEN_INVALID: 4607,
  PASSPORT_CLIENT_TOKEN_EXPIRED: 4608,
  PASSPORT_CLIENT_INVALID_ISSUER: 4609,
  PASSPORT_CLIENT_INCORRECT_ISSUER: 4610,
  PASSPORT_CLIENT_INCORRECT_AUDIENCE: 4611
}
